import { PDFDocument, PDFFont } from "pdf-lib";

export enum PlaceholderType {
  Text = "text",
  Date = "date",
  Placeholder = "placeholder",
  Image = "image",
  Signature = "signature",
}

export type PlaceholderOptions = any; //Record<string, unknown>;
export type PlaceholderData = any; //Record<string, unknown>;
export interface PlaceholderBoundingBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface DocumentPlaceholder<
  TOptions extends PlaceholderOptions = PlaceholderOptions,
  TData extends PlaceholderData = PlaceholderData,
> extends PlaceholderBoundingBox {
  id: string;
  type: PlaceholderType;
  page: number;
  options: TOptions;
  data?: TData;
  fillBox?: boolean;
}

export interface ModifyPdfOptions {
  timeZone: string;
  locale: string;
  debugBoxes?: boolean;
  throwOnError?: boolean;
}

export type CommonDrawOptions = Partial<ModifyPdfOptions> & {
  font?: PDFFont;
  pdfDoc: PDFDocument;
};
